import { teal } from "@material-ui/core/colors";

export const primary = teal;

export const secondary = {
  main: "#96000F",
  light: "#AB333F",
  dark: "#69000A",
  contrastText: "#fff",
};
